import { course } from "@/api/course";
import { login } from "@/api/user";
import { weekdays } from "moment";

export default {
    webTitle: '邻童运动管理后台',
    login: '登录',
    home: '首页',
    unionpay: '银联',
    unionpay_signed_on: '银联签约入驻',
    operator: '运营用户',
    operator_leader: '主理人',
    operator_leader_phone: '主理人电话',
    operator_coach: '教练',
    operator_user: '用户',
    operator_student: '学员',
    operator_master: '区域运营商',
    operator_merchant: '城市中心',
    operator_leader_management: '主理人管理',
    operator_coach_management: '教练管理',
    operator_user_management: '用户管理',
    operator_student_management: '学员管理',
    operator_master_management: '区域运营商管理',
    operator_merchant_management: '城市中心管理',
    operator_coach_level: '教练等级管理',
    classes: '课程拼班',
    classes_course: '课程列表',
    classes_scheduling: '周期性列表',
    classes_lesson_package: '课包列表',
    classes_list: '拼班列表',
    classes_course_category: '课程类别',
    classes_community_management: '小区管理',
    course: '课程',
    community: '小区',
    activity: '活动',
    activity_management: '活动管理',
    activity_interest_card: '权益卡管理',
    classes_coach_calendar: '教练日历',
    classes_coach_weekly: '教练周课表',
    classes_coach_lesson: '教练上课列表',
    activity_coupon: '优惠券',
    data_detail: '流水明细',
    data_order_list: '订单明细',
    data_bill_list: '流水明细',
    order_rights_cards: '权益卡明细',
    data_coupon_list: '优惠券列表',
    order_lessons: '拼班订单',
    data_account_list: '账户明细',
    system_management: '系统管理',
    system_user_list: '账号管理',
    system_role_list: '角色管理',
    operation_Logs: '系统日志',
    app_lesson_agreement_config: 'APP拼班协议',
    app_franchise_config: '加盟页面配置',
    app_coach_agreement_config: '教练合作协议',
    app_coach_notes_config: '课程注意事项',
    app_coach_summary_report_config: '课程反馈模板',
    banner_config: '首页Banner配置',
    sys_parameter_config: '系统参数配置',
    app_registration_agreement_config: 'APP注册协议',
    app_privacy_agreement_config: 'APP隐私协议',
    order_account_detail: '账户明细',
    settlement_detail: '结算明细',
    order_pay_detail: '支付流水',
    financial: '财务管理',
    financial_withdraw_list: '提现管理',
    financial_wallet_list: '运营用户钱包列表',
    financial_wallet_coach_list: '教练钱包列表',
    my_management: '我的',
    my_wallet_list: '我的钱包',
    my_withdraw_list: '我的提现',
    report: '报表统计',
    report_lesson_count: '课程创建数量统计',
    backend: '运营管理',
    backend_course_plan: '教案管理',
    invitation: '邀请加盟',
    invitation_type: '邀请奖励配置',
    invitation_list: '邀请列表',
    invitation_franchise: '招商加盟',
    invitation_user_survey: '客户待沟通',
    user_page: {
        name: '姓名',
        cellphone: '手机号',
        avatar: '头像',
        real_name: '真实姓名',
        nick_name: '昵称',
        id_card_no: '身份证',
        id_card_face: '身份证人脸面',
        id_card_insignia: '身份证国徽面',
        is_certify: '是否实名',
        is_contract: '是否合同',
        is_freeze: '是否冻结',
        role: '角色',
        add_user: '新增用户',
        edit_user: '编辑用户',
        edit_user_Role: '编辑用户角色',
        user_type: '用户类型',
        student_num: '学员数量',
        student_name: '学员姓名',
        student_age: '学员年龄',
        student_birthday: '生日',
        student_gender: '学员性别',
        benefit_card_count: '优惠券数量',
        latest_login_at: '最近登录时间',
        has_Rights_Card: '是否开通权益卡',
        rights_card_expire_at: '权益卡到期时间',
        lesson_count: '拼班次数'
    },
    user_type: {
        teamLeader: '区域运营商',
        regionalOperator: '城市中心',
        operator: '主理人',
        admin: '管理员'
    },
    achievement_type: {
        surveyCompleted: '注册并完善信息',
        trialLessonFinished: '参加体验课',
        lessonFinished: '报名正式课'
    },
    gender: {
        female: '女',
        male: '男',
    },
    rights_cards_state: {
        created: '已创建',
        paying: '支付中',
        activated: '已激活',
        obsoleted: '已作废'
    },
    order_lessons_state: {
        created: '已创建',
        paying: '支付中',
        joined: '已参加',
        quited: '已退出'
    },
    week_day: {
        Mon: '星期一',
        Tue: '星期二',
        Wed: '星期三',
        Thur: '星期四',
        Fri: '星期五',
        Sat: '星期六',
        Sun: '星期日'
    },
    course_plan_type: {
        html: '富文本',
        video: '视频',
        image: '图片',
        document: '文件'
    },
    course_page: {
        name: '课程名称',
        category: '课程类别',
        duration: '课程时长',
        judgment_time: '成班判断时间',
        remind_time: '提醒时间',
        min_number: '成班人数',
        max_number: '最多人数',
        original_price: '原价',
        card_price: '权益卡价',
        new_user_price: '新人价',
        explain: '课程说明',
        class_explain: '拼班说明',
        refund_explain: '退款说明',
        cover_picture: '封面图',
        detail_top_picture: '详情顶部图',
        operator_leader_reward: '主理人超额奖励',
        meet_number: '满足人数',
        isenable_cashback: '是否开启返现',
        set_cashback: '返现设置',
        reward: '奖励',
        work_away: '连续上课',
        course_unit: '节',
        num_unit: '个',
        course_unit_price: '元/节',
        ID: '课程号',
        community_number: '小区数量',
        relation_rightCard: '关联权益卡',
        relation_community: '关联小区'

    },
    scheduling_state: {
        processing: '进行中',
        finished: '已完成',
        canceled: '已取消',
        waitingTeamup: '待开始',
        waitngStudy: '待开课',
        inStudy: '开班中'
    },
    lesson_package_state: {
        waitingTeamup: '待成团',
        teamup: '已成团',
        canceled: '已取消',
        finished: '已完成',
    },
    withdraw_state: {
        pending: '待审核',
        approved: '已通过',
        rejected: '已拒绝'
    },
    scheduling_page:{
        ID: '班级号',
        name: '班级名称',
        state: '拼班状态',
        work_time: '上课时间',
        period_time: '周期时间',
        work_times: '周期次数',
        long_time: '长期',
        is_long_time: '是否长期',
        num: '班级人数',
        day_Of_week: '星期',
        edit_coach: '修改教练',
        edit_work_time: '修改上课时间',
        edit_work_times: '修改拼班周次',
        edit_remark: '修改拼班备注',
        cancel_class: '取消拼班',
        edit_ratio: '修改分账比例',
        cashback_schedule: '返现进度',
        work_time_pre: '上课时间前',
        cutOff_time: '截止报名',
        remind_tip:'提醒教练/学员上课'
    },
    lesson_page:{
        ID: '拼班号',
        num: '拼班人数',
        clockout_time: '打卡时间',
        waitingTeamup: '待开课',
        edit_cutOff_time: '修改截止时间',
        edit_class_num: '修改拼班人数',
        view_student: '查看学员'
    },
    community_page: {
        name: '小区名称',
        address: '小区地址',
        city: '所在城市',
        location: '所在位置',
        image: '小区照片',
        parentGroupQrCode: '家长群二维码',
        coach_num: '教练数量',
        course_num: '课程数量',
        bindOperator: '关联主理人',
    },
    coach_page: {
        coach_level: '教练等级',
        residence: '常住地',
        team_master_num: '区域运营商数量',
        course_num: '关联课程数量',
        course_times: '累计课时',
        community_num: '关联小区数量',
        total_score: '累计评分',
        bank_card: '银行卡信息',
        set_level: '设置等级',
        bind_community_course: '关联小区和课程',
        set_time: '设置排课时间'
    },
    coach_level_page: {
        name: '等级名称',
        level: '等级',
        settle_mode: '结算模式',
        evaluate_score: '平均评价分',
        class_hour: '累计课时',
        class_fee: '课时费',
        class_percent: '课时比例',
        minimumGuarantee: '固定'
    },
    bank_card_info: {
        bank_name: '银行名称',
        bank_account_name: '姓名',
        bank_account_number: '卡号'
    },
    interest_card_page: {
       user_price: '用户价',
       price: '价格',
       operator_price: '主理人价格',
       duration: '有效期',
       start_time: '开始时间',
       end_time: '结束时间',
       activity_view: '查看活动',
       active_at: '活动开始时间',
       expire_at: '活动结束时间',
    },
    right_card_page: {
        id: '权益卡ID',
        name: '权益卡名称',
        image: '权益卡图片',
        price: '权益卡价格',
        operatorPrice: '主理人价格',
        duration: '有效期',
        duration_unit: '有效期单位',
        description: '权益卡说明',
    },
    common_page: {
        date: '日期',
        add: '新增',
        edit: '编辑',
        delete: '删除',
        operate: '操作',
        refresh: '刷新',
        search: '查询',
        more_filters: '更多筛选',
        more: '更多',
        reset: '重置',
        download: '下载',
        import: '导入',
        column_set: '列设置',
        enable: '启用',
        disabled: '禁用',
        cancel: '取消',
        confirm: '确认',
        save: '保存',
        remark: '备注',
        name: '名称',
        username: '用户名',
        fullname: '姓名',
        cellphone: '手机号',
        contact_phone: '联系电话',
        id: '编号',
        isenable: '是否启用',
        creator: '创建人',
        create_time: '创建时间',
        latest_login_time: '最后登录时间',
        minutes: '分钟',
        hours: '小时',
        days: '天',
        months: '月',
        years: '年',
        rate: '比例',
        add1: '添加',
        increase: '增加',
        reduce: '减少',
        enable_statue: '是否有效',
        label_city: '所在城市',
        label_area: '所在区域',
        waittingCheck: '待审核',
        pass: '通过',
        refused: '拒绝',
        register_time: '注册时间',
        operate_time: '操作时间',
        distribution_time: '分配时间',
        operator: '操作人',
        icon: '图标',
        link: '链接',
        image: '图片',
        thumbnail: '缩略图',
        lng: '经度',
        lat: '纬度',
        lngLat: '经纬度',
        cert_type: '证件类型',
        cert_no: '证件号码',
        adult:'成人',
        children:'儿童',
        passport: '护照',
        idCard: '身份证',
        taiwanPass: '台湾省份证',
        hongkongAndMacaoPass: '港澳通行证',
        foreignersPermanentResidence: '外国人永居证明',
        enterprise: '企业',
        personal: '个人',
        is_default: '是否默认',
        content: '内容',
        operator_cellphone: '操作人手机号',
        input_placeholder: '请输入',
        select_placeholder: '请选择',
        input_name_id_placeholder: '请输入名称或者编号',
        ture: '是',
        false: '否',
        select_all: '全选',
        user_group: '用户组',
        log: '日志',
        model: '业务模块',
        config: '配置',
        interest_card_name: '权益卡名称',
        operate_success_tip: '操作成功！',
        input_email_placeholder: '请输入正确的邮箱地址！',
        operate_fail_tip: '操作失败，请联系管理员！',
        query_fail_tip: '查询失败，请联系管理员！',
        delete_confirm_tip: '是否确认删除{name}吗？',
        enable_confirm_tip: '是否确认启用{name}吗？',
        disable_confirm_tip: '是否确认禁用{name}吗？',
        save_confirm_tip: '是否确认保存{name}吗？',
        confirm_tip: '是否确认{name}吗？',
        draw: '画',
        count_total: '共 {count} 条',
        fence: '围栏',
        state: '状态',
        audit_state: '审核状态',
        audit_time: '审核时间',
        auditor: '审核人',
        audit: '审核',
        worksheet_state: '工单状态',
        type: '类型',
        title: '标题',
        is_success: '是否成功',
        issue_at: '生效时间',
        expire_at: '过期时间',
        sort: '排序',
        corner_title: '高亮标题',
        sub_title: '子标题',
        num: '数量',
        amount: '金额',
        client_view: '客户端',
        app: 'APP',
        miniProgram: '小程序',
        h5: 'H5',
        outsideMiniProgram: '外部小程序',
        innerPath: '自定义页面',
        page_html: '页面',
        all: '全部',
        view: '显示',
        preview: '预览',
        visiable: '是否显示',
        hide: '隐藏',
        detail: '详情',
        details: '明细',
        category: '分类',
        address: '地址',
        contacts_name: '联系人姓名',
        contacts_name1: '联系人',
        contacts_cellphone: '联系人电话',
        business_hours: '营业时间',
        electricity_price_type: '电价类型',
        electricity_price: '电价',
        rangely_prices_month: '按月配置电价',
        period_prices_default: '默认配置电价',
        period_config: '时间段配置',
        period_template: '多阶段模板',
        price: '价格',
        current: '现在',
        previous: '之前',
        change: '变动',
        bind: '绑定',
        tag: '标签',
        fixed: '固定',
        fixedMin: '最低价',
        period: '阶段',
        upload: '上传',
        progress: '进度',
        penalty_amount: '罚金(元)',
        distance: '距离',
        time: '时间',
        minute: '{count}分钟',
        hour: '{count}小时',
        time_short: '{h}小时{m}分钟',
        time_full: '{h}小时{m}分钟{s}秒',
        km: '{count}公里',
        m: '{count}米',
        is_finished: '是否完成',
        is_canceled: '是否取消',
        is_distribution: '是否分配',
        is_public: '是否公开',
        is_open: '是否开启',
        upload_file_format_error_tip: '文件格式出错,请确保上传的是 {name} 文件!',
        upload_file_max_size_error_tip: '文件大小超出限制,请保证文件大小在 {size} 以内!',
        appid: '应用程序ID',
        param: '参数',
        paramkey: '参数名',
        paramVal: '参数值',
        row: '行',
        row_update: '调整行',
        description: '介绍',
        unit: '单位',
        spec: '规格',
        spec_info: '规格信息',
        canceled: '已取消',
        canceled_at: '取消时间',
        finished: '已完成',
        finished_at: '完成时间',
        pending: '待处理',
        other_info: '其他信息',
        appointment_time: '预约时间',
        item_info: '项目信息',
        activity_info: '活动信息',
        reference_price: '参考价',
        process_time: '处理时间',
        go_process: '去处理',
        top_img: '顶部图片',
        carousel_img: '轮播图',
        month: '月份',
        explanation_content: '说明内容',
        terminate: '终止'
    },
    login_page: {
        sms_login: '验证码登录',
        pwd_login: '账号登录',
        login: '登录',
        phone: '手机号',
        email: '邮箱',
        vercode: '验证码',
        username: '用户名',
        password: '密码',
        reset_pwd: '重置密码',
        new_pwd: '新密码',
        confirm_pwd: '确认密码',
        back: '返回',
        get_sms_code: '获取验证码',
        empty_error_tip: '请输入',
        operate_success_tip: '操作成功！',
        sms_send_success_tip: '短信发送成功！'
    },
   
    permission_role_list_page: {
        role_name: '角色名称',
        role_name_require_tip: '请输入角色名称',
        permission: '权限',
        add_role: '新增角色',
        edit_role: '编辑角色',
        enable_confirm_tip: '确认启用该角色?',
        disable_confirm_tip: '确认禁用该角色?',
        delete_confirm_tip: '确认删除该角色?',
        biz_keys: '业务键',
    },
   
    permission_codes_keys: {
        'qrcode_rule': '二维码规则',
        'bike_base_info': '车辆基本信息',
        'ecu_cmd_url': '中控下行地址',
        'role': '角色管理',
        'sys-user': '用户管理'
    },
    All_biz_keys: {
        'ALL_DISTRICT': '全部服务区',
        'ALL_ORDER_PARTITION': '全部订单分区',
        'ALL_RESPONSIBILITY': '全部责任区'
    }
}